import React from 'react'
import { Link } from 'react-router-dom'
import { Phone, Mail, MessageCircle, MapPin } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export const Footer: React.FC = () => {
  const { t } = useTranslation('footer')
  
  return (
    <footer className="bg-gray-900 text-gray-300 py-12">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-r from-kylix-primary to-kylix-secondary rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">S</span>
              </div>
              <span className="text-xl font-bold text-white">{t('brand.name')}</span>
            </div>
            <p className="text-gray-400 mb-4">
              {t('brand.description')}
            </p>
          </div>
          
          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('contact.title')}</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-kylix-secondary" />
                <a href="tel:+5515997464695" className="hover:text-white transition-colors">
                  {t('contact.phone')}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-kylix-secondary" />
                <a href="mailto:contato@smartdataerp.com.br" className="hover:text-white transition-colors">
                  {t('contact.email')}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MessageCircle className="w-4 h-4 text-kylix-secondary" />
                <a href="https://wa.me/15148826382" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                  {t('contact.whatsapp')}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="w-4 h-4 text-kylix-secondary" />
                <span>{t('contact.location')}</span>
              </li>
            </ul>
          </div>
          
          {/* Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('product.title')}</h3>
            <ul className="space-y-2">
              <li><Link to="/technology" className="hover:text-white transition-colors">{t('product.technology')}</Link></li>
              <li><Link to="/solutions" className="hover:text-white transition-colors">{t('product.solutions')}</Link></li>
              <li><Link to="/demo" className="hover:text-white transition-colors">{t('product.demo')}</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">{t('company.title')}</h3>
            <ul className="space-y-2">
              <li><Link to="/partners" className="hover:text-white transition-colors">{t('company.partners')}</Link></li>
              <li><Link to="/docs" className="hover:text-white transition-colors">{t('company.documentation')}</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">{t('company.contact')}</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-500">
          <p dangerouslySetInnerHTML={{ __html: t('copyright') }} />
          <p className="mt-2">
            <Link to="/privacidade" className="hover:text-white transition-colors">{t('privacy')}</Link>
            <span className="mx-2">·</span>
            <Link to="/termos" className="hover:text-white transition-colors">{t('terms')}</Link>
          </p>
        </div>
      </div>
    </footer>
  )
}